/**
 * Transient confirmation that something changed on the server. Not for errors
 * needing a decision — those stay inline next to the control.
 *
 * State lives in `store/toastSlice.ts`, rendering in `components/Toaster.tsx`.
 */
import { useCallback, type ReactNode } from 'react';
import { Toaster } from '../components/Toaster';
import { AnalysisRunWatcher } from '../components/AnalysisRunWatcher';
import { useAppDispatch } from '../store';
import { pushToast, type ToastTone } from '../store/toastSlice';

export type { ToastTone };

export function ToastProvider({ children }: { children: ReactNode }) {
	return (
		<>
			{children}
			<Toaster />
			<AnalysisRunWatcher />
		</>
	);
}

export function useToast() {
	const dispatch = useAppDispatch();
	return useCallback(
		(tone: ToastTone, title: string, message?: string) => {
			dispatch(pushToast({ tone, title, message }));
		},
		[dispatch],
	);
}
